import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.promise.js";
import _isFunction from "lodash/isFunction";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.is-array.js";
import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Form, Row, Col, Input, PhoneInput, Button, Dropdown, AddressInput, CheckButton, showSuccess } from 'components';
import { showApiError } from 'utils';
import { familyConnectionTypeNameSelect } from 'enums';
import { createContact, updateContact, getAllAreas } from 'services';
import { jsx as ___EmotionJSX } from "@emotion/react";
var COUNTRY_ID = 1;

var sectionStyle = function sectionStyle(theme) {
  return {
    padding: '1.4em 0',
    borderBottom: "1px solid ".concat(theme.gray100),
    '&:first-of-type': {
      paddingTop: 0
    },
    '&:last-of-type': {
      borderBottom: 'none',
      paddingBottom: 0
    }
  };
};

var sectionTitle = function sectionTitle(theme) {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5em',
    marginBottom: '1.2em',
    '& i': {
      fontSize: '1.5rem',
      color: theme.primary
    },
    '& span': {
      fontSize: '1.2rem',
      fontWeight: 600,
      color: theme.gray600
    }
  };
};

var AddEditContactForm = function AddEditContactForm(_ref) {
  var onSubmit = _ref.onSubmit,
      borrowerIdNumber = _ref.borrowerIdNumber,
      data = _ref.data;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      areas = _useState2[0],
      setAreas = _useState2[1];

  var initialContactFormData = _objectSpread(_objectSpread({
    borrower_id_number: borrowerIdNumber,
    country_id: COUNTRY_ID,
    phone: '+359-'
  }, data), {}, {
    discretion: !!(data !== null && data !== void 0 && data.discretion)
  });

  useEffect(function () {
    fetchAreas();
  }, []);

  var fetchAreas = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$getAllAreas, _yield$getAllAreas2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getAllAreas({
                country_id: COUNTRY_ID
              });

            case 2:
              _yield$getAllAreas = _context.sent;
              _yield$getAllAreas2 = _slicedToArray(_yield$getAllAreas, 2);
              res = _yield$getAllAreas2[0];
              err = _yield$getAllAreas2[1];
              err ? showApiError(err) : setAreas(res);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchAreas() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleAddContact = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref3) {
      var values, body, method, params, _yield$method, _yield$method2, err;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              values = _ref3.values;
              body = _objectSpread(_objectSpread({}, values), {}, {
                discretion: values !== null && values !== void 0 && values.discretion ? 1 : 0
              });
              method = data ? updateContact : createContact;
              params = data ? [data === null || data === void 0 ? void 0 : data.id, _objectSpread(_objectSpread({}, data), body)] : [body];
              _context2.next = 6;
              return method.apply(void 0, params);

            case 6:
              _yield$method = _context2.sent;
              _yield$method2 = _slicedToArray(_yield$method, 2);
              err = _yield$method2[1];

              if (!err) {
                _context2.next = 11;
                break;
              }

              return _context2.abrupt("return", showApiError(err));

            case 11:
              showSuccess("\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u044A\u0442 \u0435 ".concat(data ? 'редактиран' : 'добавен', " \u0443\u0441\u043F\u0435\u0448\u043D\u043E."));
              _isFunction(onSubmit) && onSubmit();

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleAddContact(_x) {
      return _ref4.apply(this, arguments);
    };
  }();

  return ___EmotionJSX(Form, {
    onSubmit: handleAddContact,
    values: initialContactFormData
  }, ___EmotionJSX("section", {
    css: sectionStyle
  }, ___EmotionJSX("div", {
    css: sectionTitle
  }, ___EmotionJSX("i", {
    className: "las la-user"
  }), ___EmotionJSX("span", null, "\u041B\u0438\u0447\u043D\u0438 \u0434\u0430\u043D\u043D\u0438")), ___EmotionJSX(Row, {
    horizontalGap: 16
  }, ___EmotionJSX(Col, {
    sm: 12,
    md: 4
  }, ___EmotionJSX(Input, {
    formId: "first_name",
    label: "\u0418\u043C\u0435",
    required: true
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 4
  }, ___EmotionJSX(Input, {
    formId: "middle_name",
    label: "\u041F\u0440\u0435\u0437\u0438\u043C\u0435",
    required: true
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 4
  }, ___EmotionJSX(Input, {
    formId: "last_name",
    label: "\u0424\u0430\u043C\u0438\u043B\u0438\u044F",
    required: true
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 4
  }, ___EmotionJSX(Dropdown, {
    required: true,
    formId: "type",
    label: "\u0422\u0438\u043F \u0441\u0432\u044A\u0440\u0437\u0430\u043D\u043E\u0441\u0442",
    options: familyConnectionTypeNameSelect,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.value;
    }
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 4
  }, ___EmotionJSX(PhoneInput, {
    required: true,
    formId: "phone",
    label: "\u041C\u043E\u0431\u0438\u043B\u0435\u043D"
  })))), ___EmotionJSX("section", {
    css: sectionStyle
  }, ___EmotionJSX("div", {
    css: sectionTitle
  }, ___EmotionJSX("i", {
    className: "las la-map-marker-alt"
  }), ___EmotionJSX("span", null, "\u0410\u0434\u0440\u0435\u0441")), ___EmotionJSX(Row, {
    horizontalGap: 16
  }, ___EmotionJSX(Col, {
    sm: 12,
    md: 4
  }, function (formProps) {
    return ___EmotionJSX(AddressInput, {
      areas: areas,
      countryId: COUNTRY_ID,
      areaKey: "area_id",
      municipalityKey: "municipality_id",
      cityKey: "city_id",
      isNew: !data,
      formProps: formProps
    });
  }), ___EmotionJSX(Col, {
    sm: 12,
    md: 4
  }, ___EmotionJSX(Input, {
    formId: "street",
    label: "\u0423\u043B\u0438\u0446\u0430"
  }), ___EmotionJSX(Input, {
    formId: "street_number",
    label: "\u0423\u043B\u0438\u0446\u0430 \u2116"
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 4
  }, ___EmotionJSX(Input, {
    formId: "quarter",
    label: "\u041A\u0432\u0430\u0440\u0442\u0430\u043B"
  }), ___EmotionJSX(Input, {
    formId: "building",
    label: "\u0411\u043B\u043E\u043A"
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 4
  }, ___EmotionJSX(Input, {
    formId: "entrance",
    label: "\u0412\u0445\u043E\u0434"
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 4
  }, ___EmotionJSX(Input, {
    formId: "floor",
    label: "\u0415\u0442\u0430\u0436",
    inputProps: {
      inputMode: 'numeric'
    }
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 4
  }, ___EmotionJSX(Input, {
    formId: "apartment",
    label: "\u0410\u043F\u0430\u0440\u0442\u0430\u043C\u0435\u043D\u0442"
  })))), ___EmotionJSX("section", {
    css: sectionStyle
  }, ___EmotionJSX(Row, {
    horizontalGap: 16
  }, ___EmotionJSX(Col, {
    sm: 12,
    margin: "0 0 1em 0"
  }, ___EmotionJSX(CheckButton, {
    formId: "discretion"
  }, "\u0414\u0438\u0441\u043A\u0440\u0435\u0442\u043D\u043E\u0441\u0442")))), ___EmotionJSX(Row, {
    horizontalGap: 16,
    margin: "1em 0 0 0"
  }, ___EmotionJSX(Col, {
    displayFlex: true,
    md: 12,
    justify: "flex-end"
  }, function (_ref5) {
    var formSubmit = _ref5.onSubmit;
    return ___EmotionJSX(Button, {
      onClick: formSubmit
    }, ___EmotionJSX("i", {
      className: "las la-check",
      style: {
        marginRight: 6
      }
    }), data ? 'Запази промени' : 'Добави контакт');
  })));
};

AddEditContactForm.propTypes = {
  onSubmit: PropTypes.func,
  borrowerIdNumber: PropTypes.string,
  data: PropTypes.object
};
export default AddEditContactForm;